import React from 'react';

import CardFeed from 'buyside/components/presentation/CardFeed/cardFeed';
import PaginatedIndex, {
  PaginatedIndexItems,
  PaginationButton
} from 'buyside/components/presentation/Index/paginatedIndex';
import ContestIndexCard from './ContestIndexCard/contestIndexCard';

import styles from './contestIndexPageStyles.scss';

const indexItemRenderer = contest => {
  return <ContestIndexCard contest={contest} key={`contestIndex-${contest.id}`} />;
};

const ContestIndexPaginationButton = () => (
  <CardFeed className={styles.paginationButton} type="secondary">
    Load More
  </CardFeed>
);

const ContestIndexPage = ({ data }) => {
  const { indexItems, fetchNextPage, hasNextPage, promotedContest } = data;
  return (
    <React.Fragment>
      <h2 className={styles.header}>Contests</h2>
      {promotedContest && <ContestIndexCard contest={promotedContest} />}
      <h3>Past Contests</h3>
      <PaginatedIndex
        indexItems={indexItems}
        indexItemRenderer={indexItemRenderer}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
      >
        <PaginatedIndexItems />
        <PaginationButton>
          <ContestIndexPaginationButton />
        </PaginationButton>
      </PaginatedIndex>
    </React.Fragment>
  );
};

export default ContestIndexPage;
